// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file message_type.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file message_type.proto.
 */
export const file_message_type: GenFile = /*@__PURE__*/
  fileDesc("ChJtZXNzYWdlX3R5cGUucHJvdG8SC2dycGMuYXBpLnYxIicKC01lc3NhZ2VUeXBlEgoKAmlkGAEgASgDEgwKBHR5cGUYAiABKAlCBloELjtwYmIGcHJvdG8z");

/**
 * @generated from message grpc.api.v1.MessageType
 */
export type MessageType = Message<"grpc.api.v1.MessageType"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message grpc.api.v1.MessageType.
 * Use `create(MessageTypeSchema)` to create a new message.
 */
export const MessageTypeSchema: GenMessage<MessageType> = /*@__PURE__*/
  messageDesc(file_message_type, 0);

